import { patientProfileCompletionActions } from '../../../../actions/user/patient/auth/profile_completion_status';

const initialState = {
  isComplete: false,
  incompleteFields: [],
  loading: false,
  lastChecked: null,
  error: null
};

const patientProfileCompletionReducer = (state = initialState, action) => {
  switch (action.type) {
    case patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.SUCCESS:
      return {
        ...state,
        isComplete: action.payload.isComplete,
        incompleteFields: action.payload.incompleteFields,
        lastChecked: action.payload.lastChecked,
        loading: false,
        error: null
      };

    case patientProfileCompletionActions.CHECK_PROFILE_COMPLETION.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case patientProfileCompletionActions.CLEAR_PROFILE_COMPLETION:
      return initialState;

    default:
      return state;
  }
};

export default patientProfileCompletionReducer;
